// Top filter row: Live toggle | level chips | source dropdown | event count.
import type { LevelFilter } from "../types";
import { SourceDropdown } from "./SourceDropdown";

const LEVELS: { value: LevelFilter; label: string }[] = [
  { value: "all", label: "All levels" },
  { value: "info", label: "Info" },
  { value: "warning", label: "Warning" },
  { value: "error", label: "Error" },
];

export function FilterBar({
  level,
  onLevelChange,
  live,
  onLiveToggle,
  sources,
  selectedSources,
  onSelectedSourcesChange,
  eventCount,
}: {
  level: LevelFilter;
  onLevelChange: (v: LevelFilter) => void;
  live: boolean;
  onLiveToggle: (v: boolean) => void;
  sources: string[];
  selectedSources: Set<string>;
  onSelectedSourcesChange: (next: Set<string>) => void;
  eventCount: number;
}) {
  return (
    <div className="filter-bar">
      <div className="filter-bar-left">
        <button
          className={"chip live " + (live ? "live-on" : "live-off")}
          onClick={() => onLiveToggle(!live)}
          title="Polling on/off"
        >
          <span className="dot" /> Live
        </button>

        {LEVELS.map(({ value, label }) => (
          <button
            key={value}
            className={"chip " + (level === value ? "active" : "")}
            onClick={() => onLevelChange(value)}
          >
            {label}
          </button>
        ))}

        <span className="filter-sep">·</span>

        <SourceDropdown
          available={sources}
          selected={selectedSources}
          onChange={onSelectedSourcesChange}
        />
      </div>

      <div className="filter-bar-right">{eventCount} events</div>
    </div>
  );
}
